import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Tab } from './interfaces/Tab';
import { CardSize, ICard } from './interfaces/Card';
import { IMxrConfig } from './interfaces/MxrConfig';
import { Partner } from './interfaces/Partner';
import {
	GET_TAKEOVER,
	GET_MXR_CONFIG,
	GET_CURRENT_CARD,
	GET_SIZE,
	GET_SELECTED_TAB,
	GET_MXR_IMPRESSION_REPORT,
	SEND_REPORT,
	GET_MXR_VIEWED_REPORT,
} from './store/types';
import { Takeover } from './takeover';
import GoToCart from './components/go-to-cart';
import { VuexAction } from './@types';
import { IReport } from './interfaces/IReport';
@Component({
	components: {
		GoToCart,
	},
})
export default class App extends Vue {
	@Getter(GET_SELECTED_TAB) getSelectedTab!: Tab;

	@Getter(GET_CURRENT_CARD) getCurrentCard!: ICard;

	@Getter(GET_SIZE) getSize!: CardSize;

	@Getter(GET_TAKEOVER) getTakeover!: Takeover;

	@Getter(GET_MXR_CONFIG) getMxrConfig!: IMxrConfig;

	@Getter(GET_MXR_IMPRESSION_REPORT) getMxrImpression!: any;

	@Getter(GET_MXR_VIEWED_REPORT) getMXRViewedReport!: IReport;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	get classSize(): string {
		return this.getSize;
	}

	get className(): string {
		const mxr = this.getMxrConfig as IMxrConfig;
		if (mxr.retailerIntegration) {
			// eslint-disable-next-line prefer-template
			return ' ' + mxr.integratedRetailer;
		}
		if (!mxr.footerCallToAction) {
			return '';
		}
		switch (mxr.footerCallToAction.partner) {
			case Partner.WALMART:
				return ' walmart ';
			case Partner.KROGER:
				return ' kroger ';
			default:
				return '';
		}
	}

	get open() {
		return (
			this.getSelectedTab === Tab.Tab2 || this.getSelectedTab === Tab.Tab3
		);
	}

	get isKroger() {
		return this.getTakeover && this.getTakeover.Retailer === Partner.KROGER;
	}

	created() {
		this.sendReport({ ...this.getMxrImpression });

		const targetRenderDiv = document.querySelector('body');
		new IntersectionObserver((entries, observer) => {
			if (entries[0].intersectionRatio === 0) {
				return;
			}
			this.sendReport({ ...this.getMXRViewedReport });
			observer.disconnect();
		}).observe(targetRenderDiv);
	}
}
